import React from "react";
import { CreateVersionButton } from "../CreateVersion/CreateVersionButton.logic";
import { CreateVersionDialog } from "../CreateVersion/CreateVersionDialog.view";
import { VersionTable } from "./VerisonTable.logic";

// Responsible for rendering the extract version details
export const ExtractVersions: React.FC = () => {

  return (
    <>
      <CreateVersionButton />
      <CreateVersionDialog />
      <VersionTable />
    </>
  );
};
